import React, { useContext } from 'react';
import './NavTeams.css';
import CurrentUserContext from '../../Contexts/userContexts';
import { Link } from 'react-router-dom';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css';
import 'swiper/css/navigation';
import './NavTeams.css';

const NavTeamsSwipe = () => {


    const { singlePlayer, setTeamSearchValue } = useContext(CurrentUserContext)

    const arrBadge = []

    singlePlayer.map(resultBadge => arrBadge.push(resultBadge.player[0].strTeamBadge))


    let newBadge = [...new Set(arrBadge)]

    const leagueTarget = (badge) => {

        setTeamSearchValue(badge);

    }


    return (
        <div className='swipe-parent-container'>
            <div className='swipe-display'>
                <Swiper navigation={true} modules={[Navigation]} slidesPerView={5} loop={true} loopFillGroupWithBlank={true} className='swiper-container' >
                    {
                        newBadge.map(badge => (

                            <SwiperSlide >
                                <Link to='/players'>
                                    <div className='swipe-badges' key={badge} onClick={() => leagueTarget(badge)}>
                                        <div className="swipe-container-badge"></div>
                                        <img src={badge} alt="" />
                                    </div>
                                </Link>
                            </SwiperSlide>

                        ))
                    }
                </Swiper>
            </div>
        </div>
    );

}

export default NavTeamsSwipe;